module.exports = __webpack_public_path__ + "img/md-hourglass.6905b8dd.svg";